import { Modal, Button } from "react-bootstrap";
import { useContext, useState, useEffect } from "react";
import { CartContext } from "../context/CartContext";
import { UserContext } from "../context/UserContext";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { FaEdit, FaTrashAlt } from "react-icons/fa";

const Checkout = () => {

  const auth = useContext(UserContext);

  const { cart, setCart, emptyCart } = useContext(CartContext);
  const navigate = useNavigate();
  const [status, setStatus] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setshowEditModal] = useState(false);

  // Order address extraction
  const [email, setEmail] = useState(auth?.user?.email);
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [houseNo, setHouseNo] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [district, setDistrict] = useState("");
  const [pincode, setPincode] = useState("");
  const [phoneNo, setPhoneNo] = useState("");
  const [paymentMode, setPaymentMode] = useState("COD");

  const [addressData, setAddressData] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchCombinedAddresses();
  }, []);

  useEffect(() => {
    if (addressData?.length > 0) {
      setSelectedAddress(addressData[0].id); // Set the first address ID as selected
    }
  }, [addressData]);

  // Calculate total, GST, and shipping
  const total = cart.reduce(
    (sum, item) => sum + item.product.update_price * item.quantity,
    0
  );

  const totalGST = cart.reduce(
    (sum, item) =>
      sum +
      (item.product.gst / 100) * (item.product.update_price * item.quantity),
    0
  );

  const shipping = total > 500 ? 0 : 50;

  // Calculate grand total (including shipping and GST)
  const totalWithShipping = parseFloat(
    (total + totalGST + shipping).toFixed(2)
  );

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
    } else if (auth?.user?.isActive === 2 || auth?.user?.isActive === 0) {
      navigate("/");
    }
  }, [navigate, auth]);

  let products = [];
  cart.map((product) => {
    products.push({
      id: product.product.id,
      product: product.product.title,
      image: product.product.image[0],
      sku: product.product.sku,
      price: product.product.price,
      quantity: product.quantity,
      stockQty: product.product.stockQty,
      commission_per_product: product.product.commission_per_product
    });

    return products;
  });

  const authtoken = localStorage.getItem("token");

  const token = `Bearer ${authtoken}`;

  const fetchCombinedAddresses = async () => {
    try {
      // Fetch addresses
      const addressResponse = await axios.get(
        `${process.env.REACT_APP_API_URL}order/alladdress`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );

      const addressData = addressResponse?.data?.addresses || [];

      // Try fetching user info
      let combinedAddresses = [...addressData];

      const userInfoResponse = await axios.get(
        `${process.env.REACT_APP_API_URL}userinfo/alldata`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
          validateStatus: () => true, // allow manual check of status
        }
      );

      if (userInfoResponse.status === 200) {
        const userData = userInfoResponse?.data;

        const maxId = addressData.reduce(
          (max, item) => (item.id > max ? item.id : max),
          -1
        );

        const formattedUserAddress = {
          address: userData?.address,
          city: userData?.city,
          district: "NA",
          houseNo: "NA",
          id: maxId + 1,
          name: auth?.user?.name,
          phone_no: userData?.number,
          pincode: userData?.zip,
          state: userData?.state,
          uid: userData?.userId,
          profileAddress: true,
        };

        combinedAddresses.push(formattedUserAddress);
      }

      setAddressData(combinedAddresses)
    } catch (error) {
      console.error("Error fetching address or user info:", error);
      return [];
    }
  };

  const createOrder = async () => {
    setStatus(true);

    const selectedAddressData = addressData.find(
      (address) => address.id === selectedAddress
    );
    // Ensure the selected address is found
    if (!selectedAddressData) {
      toast.error("Please select an address!");
      setStatus(false);
      return;
    }
    setLoading(true);

    const modes = {
      cod: "Cash on Delivery (COD)",
      card: "Credit/Debit Card",
      upi: "UPI"
    };
    const modeofpayment = modes[paymentMode.toLowerCase()] || "Unknown";

    const order = {
      address: {
        name: selectedAddressData.name ? selectedAddressData.name : null,
        address: selectedAddressData.address
          ? selectedAddressData.address
          : null,
        houseNo: selectedAddressData.houseNo
          ? selectedAddressData.houseNo
          : null,
        city: selectedAddressData.city,
        state: selectedAddressData.state,
        district: selectedAddressData.district,
        pincode: selectedAddressData.pincode,
        phone_no: selectedAddressData.phone_no,
      },
      products: products, // Use products from the cart or wherever it's stored
      method: modeofpayment,
    };

    const orderData = {
      order: order,
      totalAmount: totalWithShipping,
    };
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}order/create`,
        JSON.stringify(orderData),
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );

      const message = response.data.message;
      const status = response.data.status;
      if (status === "error") {
        setStatus(false);
        toast.warn(message);
      } else {
        toast.success("Order successfull");
        localStorage.removeItem("cart");
        setTimeout(() => {
          emptyCart();
          setCart([]);

          navigate("/ordersuccess"); // Navigate to Order details page after successfull order
        }, 2000);
      }

      await axios.post(
        `${process.env.REACT_APP_API_URL}order/send`,
        JSON.stringify(orderData),
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
    } catch (error) {
      console.error("Error:", error);
    }
  };

  if (cart.length === 0) {
    return (
      <div className="conatiner-fluid p-5 m-5 text-center">
        <h1 className="text-dark">403</h1>
        <h6 className="text-muted mb-3">Access forbidden</h6>
        <Link to="/">Go to home</Link>
      </div>
    );
  }

  const handleModalClose = () => setShowModal(false);
  const handleModalShow = () => setShowModal(true);

  const handleSaveAddress = async () => {
    try {

      setStatus(true);

      if (email === "") {
        toast.error("Please enter your email!");
        setStatus(false);
        return;
      }

      if (name === "") {
        toast.error("Please enter your full name!");
        setStatus(false);
        return;
      }

      if (
        address === "" ||
        houseNo === "" ||
        city === "" ||
        state === "" ||
        district === "" ||
        pincode === ""
      ) {
        toast.error("Please complete your address!");
        setStatus(false);
        return;
      }

      if (phoneNo === "") {
        toast.error("Please enter your phone no!");
        setStatus(false);
        return;
      }
      const phoneRegex = /^\d{10}$/;
      if (!phoneRegex.test(phoneNo)) {
        toast.error("Please enter a valid 10-digit phone number!");
        setStatus(false);
        return;
      }

      if (paymentMode === "") {
        toast.error("Please select the payment Mode!");
        setStatus(false);
        return;
      }
      if (!pincode.trim()) {
        toast.error("Please enter your pincode!");
        setStatus(false);
        return;
      }
      if (!/^\d{6}$/.test(pincode.trim())) {
        toast.error("Invalid pincode! It must be a 6-digit number.");
        setStatus(false);
        return;
      }
      setStatus(true);

      const modeofpayment =
        paymentMode === "cod"
          ? "Cash on Delivery (COD)"
          : paymentMode === "card"
            ? "Credit/Debit Card"
            : "UPI";

      const order = {
        address: {
          email: email,
          name: name,
          address: address,
          houseNo: houseNo,
          city: city,
          state: state,
          district: district,
          pincode: pincode,
          phone_no: phoneNo,
        },
        products: products,
        method: modeofpayment,
      };

      const orderData = {
        order: order,
      };

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}order/createaddress`,
        JSON.stringify(orderData),
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.message === "error") {
        toast.warn("Error adding address");
      } else {
        toast.success("Address Added Successfullly");
        setShowModal(false);
      }
      fetchCombinedAddresses();
    } catch (err) {
      console.error("error", err);
    }
  };

  const handleEditModalClose = () => setshowEditModal(false);

  const handleEdit = async (id) => {
    setshowEditModal(true);
    setSelectedAddress(id);
  };

  const handleUpdateAddress = async () => {
    try {
      if (email === "") {
        toast.error("Please enter your email!");
        setStatus(false);
        return;
      }

      if (name === "") {
        toast.error("Please enter your full name!");
        setStatus(false);
        return;
      }

      if (
        address === "" ||
        houseNo === "" ||
        city === "" ||
        state === "" ||
        district === "" ||
        pincode === ""
      ) {
        toast.error("Please complete your address!");
        setStatus(false);
        return;
      }

      if (phoneNo === "") {
        toast.error("Please enter your phone no!");
        setStatus(false);
        return;
      }
      const phoneRegex = /^\d{10}$/;
      if (!phoneRegex.test(phoneNo)) {
        toast.error("Please enter a valid 10-digit phone number!");
        setStatus(false);
        return;
      }
      if (!pincode.trim()) {
        toast.error("Please enter your pincode!");
        setStatus(false);
        return;
      }

      if (!/^\d{6}$/.test(pincode.trim())) {
        toast.error("Invalid pincode! It must be a 6-digit number.");
        setStatus(false);
        return;
      }

      const selectedAddressData = addressData.find(
        (address) => address.id === selectedAddress
      );

      // Ensure the selected address is found
      if (!selectedAddressData) {
        toast.error("Please select an address!");
        setStatus(false);
        return;
      }
      const body = {
        addressId: selectedAddress,
        email: email,
        name: name,
        address: address,
        houseNo: houseNo,
        city: city,
        state: state,
        district: district,
        pincode: pincode,
        phone_no: phoneNo,
      };
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}order/update`,
        JSON.stringify(body),
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.message === "error") {
        toast.warn("Error updating address");
      } else {
        toast.success("Address Updated Successfully");
        setshowEditModal(false);
      }
      // getaddressdata();
      fetchCombinedAddresses();
    } catch (err) {
      console.error("err", err);
    }
  };

  const handleDelete = async (id) => {
    setAddressData((prevAddresses) => {
      if (!Array.isArray(prevAddresses)) {
        console.error("prevAddresses is not an array", prevAddresses);
        return prevAddresses; // Return unchanged if it's not an array
      }
      return prevAddresses.filter((address) => address.id !== id);
    });
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_API_URL}order/delete`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
          data: { addressId: id },
        }
      );
      if (response.data.message === "error") {
        toast.warn("Error adding address");
      } else {
        toast.success("Address Deleted  Successfullly");
      }
      fetchCombinedAddresses();
    } catch (err) {
      console.error("err", err);
    }
  };

  return (
    <>
      {auth.user != null && (
        <div className="container-fluid p-lg-5 p-md-2 p-2 mt-5">
          <div className="container mx-auto bg-light p-4 rounded">
            <Modal show={showModal} onHide={handleModalClose} centered>
              <Modal.Header closeButton>
                <Modal.Title>Add New Address</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="m-2 border-bottom pb-3">
                  <div className="border-bottom pb-3 mb-4">
                    <label htmlFor="" className="form-label">
                      Email Address
                    </label>
                    <input
                      type="email"
                      onChange={(e) => setEmail(e.target.value)}
                      className="form-control shadow-none"
                      value={email}
                    />
                  </div>
                  <div className="row p-1">
                    <div className="col-12">
                      <label htmlFor="" className="form-label">
                        Full Name
                      </label>
                      <input
                        type="text"
                        onChange={(e) => setName(e.target.value)}
                        className="form-control shadow-none"
                      />
                    </div>
                  </div>
                  <div className="p-1">
                    <label htmlFor="" className="form-label">
                      Address
                    </label>
                    <textarea
                      className="form-control shadow-none"
                      onChange={(e) => setAddress(e.target.value)}
                      rows={5}
                    ></textarea>
                  </div>
                  <div className="p-1">
                    <label htmlFor="" className="form-label">
                      Apartment / House no.
                    </label>
                    <input
                      type="text"
                      onChange={(e) => setHouseNo(e.target.value)}
                      className="form-control shadow-none"
                    />
                  </div>
                  <div className="row p-1">
                    <div className="col-6">
                      <label htmlFor="" className="form-label">
                        City
                      </label>
                      <input
                        type="text"
                        onChange={(e) => setCity(e.target.value)}
                        className="form-control shadow-none"
                      />
                    </div>
                    <div className="col-6">
                      <label htmlFor="" className="form-label">
                        State
                      </label>
                      <input
                        type="text"
                        onChange={(e) => setState(e.target.value)}
                        className="form-control shadow-none"
                      />
                    </div>
                  </div>
                  <div className="row p-1">
                    <div className="col-6">
                      <label htmlFor="" className="form-label">
                        District
                      </label>
                      <input
                        type="text"
                        onChange={(e) => setDistrict(e.target.value)}
                        className="form-control shadow-none"
                      />
                    </div>
                    <div className="col-6">
                      <label htmlFor="" className="form-label">
                        Pincode
                      </label>
                      <input
                        type="text"
                        onChange={(e) => setPincode(e.target.value)}
                        className="form-control shadow-none"
                      />
                    </div>
                  </div>
                  <div className="p-1">
                    <label htmlFor="" className="form-label">
                      Phone no.
                    </label>
                    <input
                      type="text"
                      onChange={(e) => setPhoneNo(e.target.value)}
                      className="form-control shadow-none"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="paymentMode">Mode of Payment</label>
                    <select
                      className="form-control"
                      id="paymentMode"
                      value={paymentMode}
                      onChange={(e) => setPaymentMode(e.target.value)}
                    >
                      <option value="cod" selected>Cash on Delivery (COD)</option>
                      <option value="card">Credit/Debit Card</option>
                      <option value="upi">UPI</option>
                    </select>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleModalClose}>
                  Close
                </Button>
                <Button variant="primary" onClick={handleSaveAddress}>
                  Save Address
                </Button>
              </Modal.Footer>
            </Modal>

            <Modal show={showEditModal} onHide={handleEditModalClose} centered>
              <Modal.Header closeButton>
                <Modal.Title>Update New Address</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="m-2 border-bottom pb-3">
                  <div className="border-bottom pb-3 mb-4">
                    <label htmlFor="" className="form-label">
                      Email Address
                    </label>
                    <input
                      type="email"
                      onChange={(e) => setEmail(e.target.value)}
                      className="form-control shadow-none"
                      value={email}
                    />
                  </div>
                  <div className="row p-1">
                    <div className="col-12">
                      <label htmlFor="" className="form-label">
                        Full Name
                      </label>
                      <input
                        type="text"
                        onChange={(e) => setName(e.target.value)}
                        className="form-control shadow-none"
                      />
                    </div>
                  </div>
                  <div className="p-1">
                    <label htmlFor="" className="form-label">
                      Address
                    </label>
                    <textarea
                      className="form-control shadow-none"
                      onChange={(e) => setAddress(e.target.value)}
                      rows={5}
                    ></textarea>
                  </div>
                  <div className="p-1">
                    <label htmlFor="" className="form-label">
                      Apartment / House no.
                    </label>
                    <input
                      type="text"
                      onChange={(e) => setHouseNo(e.target.value)}
                      className="form-control shadow-none"
                    />
                  </div>
                  <div className="row p-1">
                    <div className="col-6">
                      <label htmlFor="" className="form-label">
                        City
                      </label>
                      <input
                        type="text"
                        onChange={(e) => setCity(e.target.value)}
                        className="form-control shadow-none"
                      />
                    </div>
                    <div className="col-6">
                      <label htmlFor="" className="form-label">
                        State
                      </label>
                      <input
                        type="text"
                        onChange={(e) => setState(e.target.value)}
                        className="form-control shadow-none"
                      />
                    </div>
                  </div>
                  <div className="row p-1">
                    <div className="col-6">
                      <label htmlFor="" className="form-label">
                        District
                      </label>
                      <input
                        type="text"
                        onChange={(e) => setDistrict(e.target.value)}
                        className="form-control shadow-none"
                      />
                    </div>
                    <div className="col-6">
                      <label htmlFor="" className="form-label">
                        Pincode
                      </label>
                      <input
                        type="text"
                        onChange={(e) => setPincode(e.target.value)}
                        className="form-control shadow-none"
                      />
                    </div>
                  </div>
                  <div className="p-1">
                    <label htmlFor="" className="form-label">
                      Phone no.
                    </label>
                    <input
                      type="text"
                      onChange={(e) => setPhoneNo(e.target.value)}
                      className="form-control shadow-none"
                    />
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleEditModalClose}>
                  Close
                </Button>
                <Button variant="primary" onClick={handleUpdateAddress}>
                  Update Address
                </Button>
              </Modal.Footer>
            </Modal>

            <div className="row">
              <div className="col-lg-6">
                {/* <h2 className='mb-4'>Checkout</h2> */}
                <h4 className="mb-4">Checkout</h4>
                <Button
                  variant="primary"
                  className="mb-3"
                  onClick={handleModalShow}
                >
                  + Add New Address
                </Button>
                {addressData?.length > 0 ? (
                  addressData.map((address) => (
                    <div key={address.id} className="card mb-3 shadow-sm">
                      <div
                        className="border-label bg-light rounded"
                        style={{
                          position: "absolute",
                          top: "-0.6rem",
                          left: "1rem",
                          padding: "0 0.5rem",
                          fontWeight: 500,
                          fontSize: "0.9rem",
                          color: "#555",
                        }}
                      >
                        {address?.profileAddress ? 'Profile Address' : 'Added Address'}
                      </div>
                      <div className="card-body">
                        <div className="row align-items-center">
                          {/* Radio Button */}
                          <div className="col-md-1">
                            <input
                              type="radio"
                              className="form-check-input"
                              name="selectedAddress"
                              value={address.id}
                              checked={selectedAddress === address.id}
                              onChange={() => setSelectedAddress(address.id)}
                            />
                          </div>

                          {/* Address Details */}
                          <div className="col-md-9">
                            <h5 className="card-title">{address.name}</h5>
                            <p className="card-text mb-1">
                              {address.houseNo}, {address.address},{" "}
                              {address.city}
                            </p>
                            <p className="card-text mb-1">
                              {address.district}, {address.state} -{" "}
                              {address.pincode}
                            </p>
                            <p className="card-text">
                              <strong>Phone: </strong>
                              {address.phone_no}
                            </p>
                          </div>

                          {/* Edit and Delete Icons */}
                          <div className="col-md-2 text-right">
                            {
                              !address?.profileAddress &&
                              <button
                                className="btn btn-link p-0 me-3"
                                onClick={() => handleEdit(address.id)}
                              >
                                <FaEdit className="text-primary" size={20} />
                              </button>
                            }
                            {
                              !address?.profileAddress &&
                              <button
                                className="btn btn-link p-0"
                                onClick={() => handleDelete(address.id)}
                              >
                                <FaTrashAlt className="text-danger" size={20} />
                              </button>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <p>No addresses found.</p>
                )}
              </div>

              <div className="col-lg-6">
                <h4 className="mb-3">Order summary</h4>
                <div className="bg-white p-3 rounded-2">
                  <div className="p-3">
                    {cart.map((product, id) => {
                      return (
                        <div className="card mb-2" key={id}>
                          <div className="row p-3">
                            <div className="col-md-2">
                              <img
                                src={`${product?.product?.image?.length > 0
                                  ? process.env.REACT_APP_API_URL +
                                  process.env.REACT_APP_product_IMAGE_URL +
                                  product?.product?.image[0]
                                  : "https://upload.wikimedia.org/wikipedia/commons/9/92/No_Preview_1.jpg"
                                  }`}
                                className="img-fluid"
                                alt={product.thumbnail}
                              />
                            </div>
                            <div className="col-md-10">
                              <div className="card-body p-0">
                                <div className="row">
                                  <div className="col-lg-8 mb-lg-0 mb-md-2 mb-2">
                                    <h5 className="card-title">
                                      {product?.product?.title}
                                    </h5>
                                  </div>
                                  <div className="col-lg-4 cart-line-amount text-end">
                                    <h5>₹ {product?.product?.update_price}</h5>
                                  </div>
                                </div>
                                <div className="mb-2">
                                  <p className="card-text text-muted sku">
                                    SKU - {product?.product?.sku}
                                  </p>
                                </div>
                                <div>
                                  <p className="card-text text-muted">
                                    Quantity - {product?.quantity}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  <div className="border-top p-2">
                    <h4 className="text-dark fw-semibold mb-3 fs-5 d-flex justify-content-between align-content-center">
                      <span>Total amount:</span>{" "}
                      <span>₹ {total.toFixed(2)}/-</span>
                    </h4>
                    <h6 className="text-muted d-flex justify-content-between align-content-center">
                      <span>GST/TAXES:</span>{" "}
                      <span>₹ {totalGST.toFixed(2)}/-</span>
                    </h6>
                    <h6 className="text-muted d-flex justify-content-between align-content-center">
                      <span>Shipping charges:</span>{" "}
                      <span>{total > 500.0 ? "₹ 00/-" : "₹ 50/-"}/-</span>
                    </h6>
                    <h3 className="mt-4 mb-4 fw-semibold fs-5 d-flex justify-content-between align-content-center py-2 border-top border-bottom">
                      <span>Grand total:</span>{" "}
                      <span>
                        ₹{" "}
                        {parseFloat(total.toFixed(2)) > 0
                          ? totalWithShipping
                          : "0.00"}
                        /-
                      </span>
                    </h3>
                  </div>

                  {status && loading ? (
                    <button className="btn btn-success w-100" disabled>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        aria-hidden="true"
                      ></span>
                      <span role="status">Creating order...</span>
                    </button>
                  ) : (
                    <button
                      onClick={createOrder}
                      className="btn btn-success w-100"
                    >
                      Place Order
                    </button>
                  )}

                  <ToastContainer theme="dark" autoClose={2000} />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Checkout;
